import { mapGetters } from 'vuex';

export default {
    data() {
        return {
            currentPage: null,
            pageCount: null
        };
    },

    computed: {
        ...mapGetters({
            getSystemById: 'moduleCourse/getSystemById',
            currentLocale: 'moduleApp/locale'
        }),

        system() {
            return this.getSystemById(this.$route.params.systemId);
        },

        journey() {
            return this.system.journeys.find(
                journey => journey.name === this.routeStringToName(this.$route.params.journeyName)
            );
        },

        step() {
            return this.journey.steps.find(step => step.name === this.routeStringToName(this.$route.params.stepName));
        },

        progressBarPercentageWidth() {
            return Math.round(((this.currentPage + 1) / this.pageCount) * 100) + '%';
        },

        isLastSlide() {
            return this.currentPage + 1 === this.pageCount;
        }
    },

    mounted() {
        this.updateCarouselReferenceValues();
    },

    methods: {
        routeStringToName(string) {
            const firstLetterUppercase = string.charAt(0).toUpperCase();

            return firstLetterUppercase + string.slice(1).split('-').join(' ');
        },

        goToNextSlide() {
            this.$refs.carousel.goToPage(this.$refs.carousel.currentPage + 1);
            this.updateCarouselReferenceValues();
        },

        goToPreviousSlide() {
            this.$refs.carousel.goToPage(this.$refs.carousel.currentPage - 1);
            this.updateCarouselReferenceValues();
        },

        updateCarouselReferenceValues() {
            // we update these values because $refs is not reactive and we need to store carousel state in this component data property
            this.currentPage = this.$refs.carousel.currentPage;
            this.pageCount = this.$refs.carousel.pageCount;
        },

        urlifyString(string) {
            return string.toLowerCase().split(' ').join('-');
        },

        itemName(item) {
            return this.currentLocale === 'en' ? item.name : item.name_no;
        },

        goToQuizView() {
            this.$router.push({
                name: 'StepsGroupQuizView'
            });
        }
    }
};
